// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__j-Wz5","overlay":"Dialog_overlay__Isuf8","content":"Dialog_content__ZU7oH","close":"Dialog_close__hzjmk","icon":"Dialog_icon__0otUh"};